function groupScopes(scopes) {
  let uniqueScopes = Array.from(new Set(scopes.map(JSON.stringify))).map(JSON.parse);

  let super_users_scopes = {
    group: 'Super User Group',
    options: [],
  };
  let admin_scopes = {
    group: 'Admin User Group',
    options: [],
  };
  let personal_user_scopes = {
    group: 'Personal User Group',
    options: [],
  };

  let other_scopes = {
    group: 'Others',
    options: [],
  };

  uniqueScopes.forEach(function (scope) {
    if (
      scope.name.includes('_all') ||
      (scope.name.includes('system_company') &&
        !scope.name.includes('system_company_list_company') &&
        !scope.name.includes('system_company_update_company')) ||
      scope.name.includes('manage_questions') ||
      scope.name.includes('certificates_list') ||
      scope.name.includes('questionnaire_list')
    ) {
      super_users_scopes.options.push(scope);
    } else if (scope.name.includes('_company')) {
      admin_scopes.options.push(scope);
    } else if (scope.name.includes('_self')) {
      personal_user_scopes.options.push(scope);
    } else {
      other_scopes.options.push(scope);
    }
  });
  uniqueScopes = [];
  uniqueScopes.push(super_users_scopes);
  uniqueScopes.push(admin_scopes);
  uniqueScopes.push(personal_user_scopes);
  uniqueScopes.push(other_scopes);

  return uniqueScopes;
}

export default {
  groupScopes,
};
